import enums from '@/enums'
export default {

  install(Vue) {
    Vue.prototype.$enums = enums
  }

}
